import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(c1, r1, l1, sImaginary, sSquared) {
  var result = Complex.createComplex(0, r1 * l1 * sImaginary).divide(
    Complex.createComplex(r1 * l1 * c1 * sSquared + r1, l1 * sImaginary),
  );
  return result;
}

export function computeComplexFF() {
  return Complex.createComplex(0, 0);
}
